// @flow

import React from "react";
import { createContentfulRenderer, CONTENTFUL_TYPES } from "../types";
import { ContactHqForm, EstimationForm } from "@components";

const render = (content, key, locale, pageData) => {
    const formType = content?.formType;
    const countryCode = (
        pageData?.country ||
        process.env.GATSBY_COUNTRY_CODE ||
        ""
    ).toUpperCase();

    if (formType === "Estimation") {
        return (
            <EstimationForm
                agencyData={pageData?.allC21Agency}
                agencyFallbackImage={
                    pageData?.agencyFallbackImage?.childImageSharp
                }
                locale={locale}
                country={countryCode}
                contentfulData={content}
                estimationFormSuccessPage={pageData?.estimationFormSuccessPage}
            />
        );
    }

    return <ContactHqForm locale={locale} />;
};

const condition = (content) => {
    return content?.internal?.type === CONTENTFUL_TYPES.ContactHqBlock;
};

export default createContentfulRenderer(condition, render);
